import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams,
} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { timeout } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ApiService{
  private defaultTimeout = 30000; // 30 seconds default timeout

  constructor(private http: HttpClient) {
  }

  putRequest(url, data: any = {}, timeoutMs: number = this.defaultTimeout) {
    return this.http.put(url, data, {
      observe: 'response'
    }).pipe(timeout(timeoutMs));
  }

  getRequest(url, data: any = {}, timeoutMs: number = this.defaultTimeout) {
    let optionsObj:any = {};
    let searchParams = new HttpParams();

    if(url === 'profiles'){
      searchParams = searchParams.append('offset', data.offset);
      searchParams = searchParams.append('limit', data.limit);
      searchParams = searchParams.append('imsi', data.imsi);
      searchParams = searchParams.append('simNumber', data.sim_number);
      optionsObj.params = searchParams;
      url = environment.LIVE_API_URL+url;
    }else if(url === 'outboundCallConfig'){
      searchParams = searchParams.append('simNumber', data.simNumber);
      optionsObj.params = searchParams;
      url = environment.LIVE_API_URL+url;
    }else if(url === 'activeq') {
      searchParams = searchParams.append('offset', data.offset);
      searchParams = searchParams.append('limit', data.limit);
      searchParams = searchParams.append('simNumber', data.simNumber);
      optionsObj.params = searchParams;
      url = environment.LIVE_API_URL+url;
    }
    optionsObj.observe = 'response';
    return this.http.get(url, optionsObj).pipe(timeout(timeoutMs));
  }

  postRequest(url, data:any = {}, timeoutMs: number = this.defaultTimeout){
    return this.http.post(url, data, {
      observe: 'response'
    }).pipe(timeout(timeoutMs));
  }

  deleteRequest(url, data: any = {}, timeoutMs: number = this.defaultTimeout){
    return this.http.delete(url, {
      observe: 'response'
    }).pipe(timeout(timeoutMs));
  }
}
